// extracted by mini-css-extract-plugin
module.exports = {"slider":"AddOnsDiningCardWrapper_slider__1ZTrL","slider-container":"AddOnsDiningCardWrapper_slider-container__Zpfwo","link":"AddOnsDiningCardWrapper_link__C3OA4"};